"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orientation = void 0;
exports.invertDirection = invertDirection;
exports.directionOrientation = directionOrientation;
exports.orientationOfVector = orientationOfVector;
var Orientation;
(function (Orientation) {
    Orientation["VERTICAL"] = "VERTICAL";
    Orientation["HORIZONTAL"] = "HORIZONTAL";
})(Orientation || (exports.Orientation = Orientation = {}));
// For brevity, since we use these values a lot:
const { HORIZONTAL, VERTICAL } = Orientation;
function invertDirection(direction) {
    const mapping = { up: "down", down: "up", left: "right", right: "left" };
    return mapping[direction];
}
function directionOrientation(direction) {
    return ["left", "right"].includes(direction) ? HORIZONTAL : VERTICAL;
}
function orientationOfVector(vector) {
    return Math.abs(vector.x / vector.y) > 1 ? HORIZONTAL : VERTICAL;
}
//# sourceMappingURL=direction.js.map